// IOL model list and optimised SRK/T A-constants.
// Source: IOL Exchange SRS, section 1.1.1 (workbook "Constants" sheet).
// These are optimised constants and may differ from the manufacturer nominal values.
export const exchangeIOLModels = [
    {name: 'Alcon AcrySof IQ (SN60WF)', aConstant: 119.0},
    {name: 'Alcon Clareon Monofocal (SY60WF)', aConstant: 119.1},
    {name: 'B+L enVista (MX60E)', aConstant: 119.1},
    {name: 'HOYA Vivinex iSert (XY1)', aConstant: 118.9},
    {name: 'J&J TECNIS 1-Piece (ZCB00)', aConstant: 119.3},
    {name: 'J&J TECNIS Eyhance (ICB00)', aConstant: 119.3},
    {name: 'ZEISS CT LUCIA (621P)', aConstant: 120.2},
    {name: 'Alcon AcrySof Multipiece (MA60AC)', aConstant: 119.2},
    {name: 'B+L SofPort AO (LI61AO)', aConstant: 118.7},
    {name: 'J&J Sensar (AR40e)', aConstant: 118.7},
    {name: 'J&J TECNIS 3-Piece (ZA9003)', aConstant: 119.1},
    {name: 'ZEISS CT LUCIA (602)', aConstant: 117.7},
    {name: 'Alcon Clareon PanOptix (CNWTT0)', aConstant: 119.1},
    {name: 'Alcon Clareon Vivity (CNWET0)', aConstant: 119.2},
    {name: 'B+L enVista Envy (EN)', aConstant: 119.5},
    {name: 'BVI/PhysIOL FineVision (POD F)', aConstant: 118.95},
    {name: 'J&J TECNIS Symfony (ZXR00)', aConstant: 119.3},
    {name: 'J&J TECNIS PureSee (DEN00V)', aConstant: 119.3},
    {name: 'J&J TECNIS Odyssey (DRN00V)', aConstant: 119.3},
    {name: 'J&J TECNIS Synergy OptiBlue (DFR00V)', aConstant: 119.3},
    {name: 'ZEISS AT LISA tri (839MP)', aConstant: 118.6},
];

export const exchangeIOLModelNames = exchangeIOLModels.map((model) => model.name);

export function getAConstant(modelName){
    let model = exchangeIOLModels.find((m) => m.name === modelName);
    return (model)? model.aConstant.toFixed(2) : "";
}

// Reasons for exchange (SRS 1.1 / 1.3). Recorded, not used in the math.
export const exchangeReasons = [
    'Poor quality of vision',
    'Negative dysphotopsias',
    'Positive dysphotopsias',
    'Starbursts, glare or haloes',
    'Refractive surprise',
    'Other',
];
